var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(" 全部区域代理 "),
            _c("span", { staticClass: "sub" }, [
              _vm._v(
                "默认只列生效记录。交接产生的历史行要勾「含已失效」才出，否则一个区会看到好几条"
              ),
            ]),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth",
                    attrs: {
                      options: _vm.cityOptions,
                      props: _vm.cascaderProps,
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择省/市/区，留空查全国",
                    },
                    on: { change: _vm.onListRegionChange },
                    model: {
                      value: _vm.listRegionIds,
                      callback: function ($$v) {
                        _vm.listRegionIds = $$v
                      },
                      expression: "listRegionIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { placeholder: "联系人姓名或手机号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loadAgentList(1)
                      },
                    },
                    model: {
                      value: _vm.listQuery.contact,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.listQuery,
                          "contact",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "listQuery.contact",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.loadAgentList(1)
                        },
                      },
                      model: {
                        value: _vm.listQuery.includeInactive,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "includeInactive", $$v)
                        },
                        expression: "listQuery.includeInactive",
                      },
                    },
                    [_vm._v("含已失效")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadAgentList(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.resetAgentList } }, [
                    _vm._v("重置"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.openAgentDialog },
                    },
                    [_vm._v("开通代理")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.agentList, size: "small", border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "省 / 市 / 区",
                  "min-width": "240",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.distributionRegionLabel(
                              row.regionCode,
                              row.regionName
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "代理", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(_vm.agentName(row)))]),
                        _vm.agentPhone(row)
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v(_vm._s(_vm.agentPhone(row))),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.contactName || "-"))]),
                        row.contactPhone
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v(_vm._s(row.contactPhone)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "名下团长", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.leaderCount || 0))]),
                        _c(
                          "el-button",
                          {
                            staticClass: "ml6",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewLeaders(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "合作期", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.termText(row)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-switch", {
                          attrs: {
                            value:
                              row.status === 1 && Number(row.activeKey) === 0,
                            disabled: !(
                              row.status === 1 && Number(row.activeKey) === 0
                            ),
                            "active-color": "#13ce66",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onToggleStatus(row)
                            },
                          },
                        }),
                        _c(
                          "el-tag",
                          {
                            staticClass: "ml6",
                            attrs: {
                              size: "mini",
                              type: _vm.agentTagType(row),
                            },
                          },
                          [_vm._v(_vm._s(_vm.agentStatusText(row)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "开通时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "220", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewRegion(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openEditDialog(row)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        row.status === 1 && Number(row.activeKey) === 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openHandoverDialog(row)
                                  },
                                },
                              },
                              [_vm._v("交接")]
                            )
                          : _vm._e(),
                        row.status === 1 &&
                        Number(row.activeKey) === 0 &&
                        Number(row.leaderCount || 0) === 0
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.listQuery.size,
                  "current-page": _vm.listQuery.page,
                  total: _vm.agentTotal,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.loadAgentList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.regionCode
        ? _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "box-card mt16",
              attrs: { shadow: "never", bordered: false },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("当前生效代理"),
              ]),
              _vm.agent
                ? _c(
                    "el-form",
                    {
                      staticClass: "agent-detail",
                      attrs: { "label-width": "110px" },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "联系人：" } },
                                [_vm._v(_vm._s(_vm.agent.contactName || "-"))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "联系方式：" } },
                                [_vm._v(_vm._s(_vm.agent.contactPhone || "-"))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "名下团长数：" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.agent.leaderCount || 0)),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml6",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewLeaders(_vm.agent)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "状态：" } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          _vm.agent.status === 1
                                            ? "success"
                                            : "info",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.agent.status === 1
                                              ? "生效"
                                              : "已失效"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "开通时间：" } },
                                [_vm._v(_vm._s(_vm.agent.createTime || "-"))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "empty" }, [
                    _vm._v(
                      _vm._s(
                        _vm.regionCode
                          ? "该区域暂无生效代理，团长申请将由平台兜底审批"
                          : "请在上方列表点「查看」选一个区域"
                      )
                    ),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _vm.regionCode && _vm.queue.length
        ? _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "box-card mt16",
              attrs: { shadow: "never", bordered: false },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("候补队列"),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.queue, size: "small", border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "60", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                          },
                        },
                      ],
                      null,
                      false,
                      3594593631
                    ),
                  }),
                  false
                    ? _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "70" },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      prop: "realName",
                      label: "姓名",
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phone",
                      label: "手机号",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "description",
                      label: "说明",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.queueTagType(row.status),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.queueStatusText(row.status))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2925351581
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "queueTime",
                      label: "排队时间",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.status === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEnable(row)
                                        },
                                      },
                                    },
                                    [_vm._v("启用")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4005438490
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.regionCode && _vm.assignments.length
        ? _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "box-card mt16",
              attrs: { shadow: "never", bordered: false },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(" 历史归属版本 "),
                _c("span", { staticClass: "sub" }, [
                  _vm._v(
                    "交接会让版本号递增，历史订单按当时的版本追溯归属，不回溯改算"
                  ),
                ]),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.assignments, size: "small", border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "60", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                          },
                        },
                      ],
                      null,
                      false,
                      3594593631
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "version", label: "版本", width: "70" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "agentId",
                      label: "代理记录 ID",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "省 / 市 / 区", "min-width": "240" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.distributionRegionLabel(
                                    row.regionCode || _vm.regionCode,
                                    row.regionPath
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2370954439
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "startTime",
                      label: "生效时间",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "失效时间", "min-width": "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(_vm._s(row.endTime || "当前生效"))]
                          },
                        },
                      ],
                      null,
                      false,
                      2936372588
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "handoverReason",
                      label: "交接原因",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "开通区域代理",
            visible: _vm.agentDialog,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.agentDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 同一个省 / 市 / 区允许开通多个不同账号的代理，层级之间也可以重叠。 同一账号在同一区域不能重复开通，该区域佣金按有效代理人数均分。 申请资料审核通过后即可启用，无需等待该区其他代理停用。 "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "agentForm",
              attrs: {
                model: _vm.agentForm,
                rules: _vm.agentRules,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "区域", prop: "regionCode" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth",
                    attrs: {
                      options: _vm.cityOptions,
                      props: _vm.cascaderProps,
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择省/市/区",
                    },
                    on: { change: _vm.onAgentRegionChange },
                    model: {
                      value: _vm.agentForm.regionIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.agentForm, "regionIds", $$v)
                      },
                      expression: "agentForm.regionIds",
                    },
                  }),
                  _vm.agentForm.regionCode
                    ? _c("div", { staticClass: "uid-hint" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.distributionRegionLabel(
                                _vm.agentForm.regionCode,
                                _vm.agentForm.regionName
                              )
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代理账号", prop: "agentUid" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "reserve-keyword": "",
                        placeholder: "搜代理本人的小程序昵称 / 手机号",
                        "remote-method": _vm.searchAgentUser,
                        loading: _vm.uidChecking,
                      },
                      model: {
                        value: _vm.agentForm.agentUid,
                        callback: function ($$v) {
                          _vm.$set(_vm.agentForm, "agentUid", $$v)
                        },
                        expression: "agentForm.agentUid",
                      },
                    },
                    _vm._l(_vm.userOptions, function (u) {
                      return _c("el-option", {
                        key: u.uid,
                        attrs: {
                          label:
                            (u.nickname || "（未设昵称）") +
                            "　" +
                            (u.phone || ""),
                          value: u.uid,
                          disabled: !u.valid,
                        },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "uid-hint" }, [
                    _vm._v(
                      " 就是代理本人登录微信小程序的那个账号，不另发账号密码。 他必须先在小程序注册/登录过才搜得到；选中后他下次打开小程序即可看到「代理中心」。 "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人", prop: "contactName" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.agentForm.contactName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "contactName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式", prop: "contactPhone" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.agentForm.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "contactPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("开通资质"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "企业名称", prop: "companyName" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "100", placeholder: "与营业执照一致" },
                    model: {
                      value: _vm.agentForm.companyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "companyName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.companyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "统一社会信用代码", prop: "licenseNo" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.agentForm.licenseNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "licenseNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.licenseNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "营业执照", prop: "licenseImage" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "cert-upload",
                      attrs: {
                        action: "",
                        "http-request": function (p) {
                          return _vm.uploadCert(p, "licenseImage")
                        },
                        "show-file-list": false,
                        accept: "image/*",
                      },
                    },
                    [
                      _vm.agentForm.licenseImage
                        ? _c("img", {
                            staticClass: "cert-image",
                            attrs: { src: _vm.agentForm.licenseImage },
                          })
                        : _c("div", { staticClass: "cert-placeholder" }, [
                            _c("i", { staticClass: "el-icon-plus" }),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "法人姓名", prop: "legalPerson" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.agentForm.legalPerson,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "legalPerson",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.legalPerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "法人身份证号", prop: "idCardNo" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: {
                      maxlength: "18",
                      placeholder: _vm.queueHasIdCard
                        ? "留空沿用申请人提交的号码"
                        : "18 位",
                    },
                    model: {
                      value: _vm.agentForm.idCardNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.agentForm,
                          "idCardNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "agentForm.idCardNo",
                    },
                  }),
                  _c("div", { staticClass: "uid-hint" }, [
                    _vm._v(
                      " 身份证号在后端加密存储，列表与详情只显示脱敏值，保存后这里不再回显明文。 "
                    ),
                    _vm.queueHasIdCard
                      ? _c("span", [
                          _vm._v("申请人已提交，留空即沿用；要更正才填新号。"),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "身份证照片", prop: "idCardFront" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "cert-upload",
                      attrs: {
                        action: "",
                        "http-request": function (p) {
                          return _vm.uploadCert(p, "idCardFront")
                        },
                        "show-file-list": false,
                        accept: "image/*",
                      },
                    },
                    [
                      _vm.agentForm.idCardFront
                        ? _c("img", {
                            staticClass: "cert-image",
                            attrs: { src: _vm.agentForm.idCardFront },
                          })
                        : _c("div", { staticClass: "cert-placeholder" }, [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _c("span", [_vm._v("人像面")]),
                          ]),
                    ]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticClass: "cert-upload",
                      attrs: {
                        action: "",
                        "http-request": function (p) {
                          return _vm.uploadCert(p, "idCardBack")
                        },
                        "show-file-list": false,
                        accept: "image/*",
                      },
                    },
                    [
                      _vm.agentForm.idCardBack
                        ? _c("img", {
                            staticClass: "cert-image",
                            attrs: { src: _vm.agentForm.idCardBack },
                          })
                        : _c("div", { staticClass: "cert-placeholder" }, [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _c("span", [_vm._v("国徽面")]),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "合作期" } },
                [
                  _c("el-date-picker", {
                    staticClass: "term-picker",
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.agentForm.term,
                      callback: function ($$v) {
                        _vm.$set(_vm.agentForm, "term", $$v)
                      },
                      expression: "agentForm.term",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "tips" }, [
                _vm._v(" 留空表示长期有效。"),
                _c("b", [_vm._v("到期后该代理的全部功能立即不可用")]),
                _vm._v(
                  " —— 审批团长申请、名下团长、分成明细、邀请码一律拒绝，该区在分账时视同无代理走平台兜底。 已产生的分成不受影响。 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.agentDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitOpen },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "修改代理", visible: _vm.editDialog, width: "560px" },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 只能改合同信息与合作期。"),
            _c("b", [_vm._v("换人请用「代理交接」")]),
            _vm._v(
              " —— 那条路会校验待结算收益并开新的归属版本，在这里改人会让历史业绩凭空转到别人名下。 "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.editForm,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "区域" } }, [
                _vm._v(
                  _vm._s(
                    _vm.distributionRegionLabel(
                      _vm.editForm.regionCode,
                      _vm.editForm.regionName
                    )
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "代理" } }, [
                _vm._v(_vm._s(_vm.editForm.agentName)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "联系人" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.editForm.contactName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editForm,
                          "contactName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editForm.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.editForm.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editForm,
                          "contactPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editForm.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "合作期" } },
                [
                  _c("el-date-picker", {
                    staticClass: "term-picker",
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.editForm.term,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "term", $$v)
                      },
                      expression: "editForm.term",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitEdit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "代理交接",
            visible: _vm.handoverDialog,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.handoverDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 交接后原代理立即失去代理端全部功能，历史订单仍按当时快照结算、"
            ),
            _c("b", [_vm._v("不回溯改算")]),
            _vm._v("。 "),
            _c("br"),
            _vm._v(" ⚠️ 现任的"),
            _c("b", [_vm._v("待结算收益不会自动校验")]),
            _vm._v(
              " —— 后端那道「未结清不允许交接」的判定要传入待结算金额， 而代理侧目前没有余额表（只有资金流水），这里传不出真实数字。交接前请先人工确认已结清。 "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "handoverForm",
              attrs: {
                model: _vm.handoverForm,
                rules: _vm.handoverRules,
                "label-width": "130px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "区域" } }, [
                _vm._v(
                  _vm._s(
                    _vm.distributionRegionLabel(
                      _vm.handoverForm.regionCode,
                      _vm.handoverForm.regionName
                    )
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "现任代理" } }, [
                _vm._v(_vm._s(_vm.handoverForm.currentAgent)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "新代理账号", prop: "newAgentUid" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "reserve-keyword": "",
                        placeholder: "搜新代理本人的小程序昵称 / 手机号",
                        "remote-method": _vm.searchAgentUser,
                        loading: _vm.uidChecking,
                      },
                      model: {
                        value: _vm.handoverForm.newAgentUid,
                        callback: function ($$v) {
                          _vm.$set(_vm.handoverForm, "newAgentUid", $$v)
                        },
                        expression: "handoverForm.newAgentUid",
                      },
                    },
                    _vm._l(_vm.userOptions, function (u) {
                      return _c("el-option", {
                        key: u.uid,
                        attrs: {
                          label:
                            (u.nickname || "（未设昵称）") +
                            "　" +
                            (u.phone || ""),
                          value: u.uid,
                          disabled: !u.valid,
                        },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "uid-hint" }, [
                    _vm._v(
                      " 同样是他登录微信小程序的那个账号，必须先注册/登录过才搜得到。 交接后原代理立即失去代理端全部功能，历史订单仍按当时快照结算、不回溯改算。 "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "交接原因", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.handoverForm.reason,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.handoverForm,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "handoverForm.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.handoverDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitHandover },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }